// src/icons/svgs/italic.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgItalic = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.685 4.39h4.87a.778.778 0 1 1 0 1.555h-4.358l-6.722 17.11h4.97a.778.778 0 0 1 0 1.556h-11a.778.778 0 1 1 0-1.555h4.358l6.722-17.111h-4.97a.778.778 0 1 1 0-1.556z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgItalic);
var italic_default = ForwardRef;
export {
  italic_default as TextItalic
};
